import { LoadableAfterPaint } from '@confluence/loadable';

export const MarketplaceAppsContainer = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-AppsContainer" */ './AppsContainer'))
			.MarketplaceAppsContainer,
});
